<template>
  <div
    v-bind:class="{ opaloading: loading }"
    class="container episode-page"
    v-if="render"
    v-bind:style="background(episodeObj)"
  >
    <!--    <BackButton class="back-position" :to="asset.url"></BackButton>-->
    <div class="container">
      <div class="row">
        <div class="col-12">
          <span class="metadata"
            >{{ asset.year }} ‧ {{ episodeObj.minutes }} min ‧
            <span
              class="genres"
              v-for="(genre, i) in asset.genres"
              v-bind:key="i"
            >
              {{ genre }}
            </span>
          </span>
          <h1 class="movie-title">
            {{ serie.title }}:
            {{ $t("detail_page.season") }}
            {{ episodeObj.season }},
            {{ episodeObj.title }}
          </h1>
          <div class="buttons">
            <router-link class="btn red-button" :to="{ name: 'register' }">
              {{ $t("detail_page.subscribe") }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="row metadata-description">
        <div class="col-md-6">
          <h2>{{ $t("detail_page.about") }}</h2>
          <p>{{ episodeObj.overview }}</p>
        </div>
        <div class="col-md-6 text-gray-3">
          <p>
            <strong>{{ $t("detail_page.country") }}</strong>
            <span>{{ asset.country }}</span>
          </p>
          <p>
            <strong>{{ $t("detail_page.directors") }}</strong>
            <span>{{ director(asset.directors) }}</span>
          </p>
          <p>
            <strong>{{ $t("detail_page.cast") }}</strong>
            <span>{{ casting(asset.actors) }}</span>
          </p>
        </div>
      </div>
    </div>
    <hr class="divider mb-1" />
    <template v-if="renderNext">
      <span class="text-gray-3 float-right"
        >{{ nextNolimits.length }} {{ $t("detail_page.episodes") }}</span
      >
      <h2 class="next-episodes">{{ $t("detail_page.next_episodes") }}</h2>
      <div class="row">
        <episode-card
          class="col-md-4"
          v-for="(episode, index) in next"
          :key="index"
          :episode="episode"
          :position="index"
          :img-alt="
            $t('detail_page.next_episode_alt', {
              episode: episode.title,
              show: serie.title,
              season: episode.season,
            })
          "
          :img-title="
            $t('detail_page.next_episode_title', {
              episode: episode.title,
              season: episode.season,
            })
          "
          :slug="asset.slug"
        />
      </div>
      <button
        v-if="limited"
        @click="limited = false"
        class="btn outline-white all-episodes"
      >
        {{ $t("detail_page.view_all_episodes") }}
      </button>
      <hr class="divider mt-1" />
    </template>
  </div>
  <div v-else class="skeleton container">
    <img src="@/assets/img/details/skeleton.svg" />
  </div>
</template>

<script>
import { OrizonApiClient } from "@/services/OrizonApiClient";
import EpisodeCard from "@/components/landing/carousel/EpisodeCard.vue";
import { i18n } from "@/functional/languages";
import MetaService from "@/services/MetaService";
import { useMeta } from "vue-meta";

const apiClient = new OrizonApiClient();
export default {
  name: "EpisodePage",
  components: { EpisodeCard },
  props: {
    slug: {
      type: String,
      required: true,
    },
    season: {
      type: String,
      required: true,
    },
    episode: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  methods: {
    background(episodeObj) {
      return {
        background: "url('" + episodeObj.img + "') no-repeat top center",
        backgroundSize: "contain",
      };
    },
    director(directors) {
      return directors.map((d) => d.name).join(", ");
    },
    casting(actors) {
      return actors.map((d) => d.name).join(", ");
    },
    setMeta() {
      MetaService.clearDefaultCanonical();
      return useMeta(
        {
          title: i18n.global.t("meta.episodes.title", {
            show: this.serie.title,
            season: this.episodeObj.season,
            episode: this.episodeObj.title,
          }),
          htmlAttrs: { lang: i18n.global.locale },
          meta: [
            MetaService.robotIndex(),
            MetaService.description(
              i18n.global.t("meta.episodes.description", {
                show: this.serie.title,
                season: this.episodeObj.season,
                episode: this.episodeObj.title,
              })
            ),
          ],
          link: [...MetaService.canonicalLinks(this.$route["path"])],
        },
        this.$metaManager
      );
    },
    fetchAsset(slug) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      apiClient.get("/asset/" + slug).then((response) => {
        this.loading = false;
        if (response.error === null) {
          if (this.type === "movie") {
            this.movie = response.data;
          } else {
            this.serie = response.data;
            this.metaData = this.setMeta();
          }
        } else {
          this.$router.push({ name: "404" });
        }
      });
    },
  },
  computed: {
    episodeObj() {
      return this.serie.seasons
        .find((s) => s.season === this.season)
        .episodes.find((e) => e.episode === this.episode);
    },
    next() {
      return this.serie.seasons
        .find((s) => s.season === this.season)
        .episodes.filter((e) => parseInt(e.episode) > parseInt(this.episode))
        .slice(0, this.limited ? 3 : 1000);
    },
    nextNolimits() {
      return this.serie.seasons
        .find((s) => s.season === this.season)
        .episodes.filter((e) => parseInt(e.episode) > parseInt(this.episode));
    },
    asset() {
      return this.type === "movie" ? this.movie : this.serie;
    },
    render() {
      return Object.keys(this.asset).length > 0;
    },
    renderNext() {
      return Object.keys(this.next).length > 0;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (typeof to.params.slug !== "undefined") {
        vm.fetchAsset(to.params.slug);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (typeof to.params.slug !== "undefined") {
      this.fetchAsset(to.params.slug);
    }
    next();
  },
  mounted() {
    if (typeof this.slug !== "undefined") {
      this.fetchAsset(this.slug);
    }
    console.log("mounted");
  },
  updated() {
    MetaService.updateDescription(
      i18n.global.t("meta.episodes.description", {
        show: this.serie.title,
        season: this.episodeObj.season,
        episode: this.episodeObj.title,
      })
    );
    MetaService.updateTitle(
      i18n.global.t("meta.episodes.title", {
        show: this.serie.title,
        season: this.episodeObj.season,
        episode: this.episodeObj.title,
      })
    );
    MetaService.clearDefaultCanonical();
    MetaService.updateCanonical(this.$route["path"]);
    console.log("updated");
  },
  data() {
    return {
      limited: true,
      loading: false,
      serie: {},
      metaData: {},
    };
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/colors";
@media (max-width: 1024px) {
  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 100% !important;
  }
}
/* Define la animación */
@keyframes fade {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}

.skeleton {
  animation: fade 2s ease-in-out infinite;
}
.episode-page {
  &.opaloading {
    opacity: 0.1;
    transition: opacity 2s ease-in-out;
  }
  .back-position {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    padding: 1em;
  }
  .next-episodes {
    font-size: 1.2em;
    font-weight: 400;
    margin-bottom: 2em;
  }
  .all-episodes {
    display: block;
    margin: 1em auto;
    &:hover {
      background: #ffffff;
    }
  }
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
  padding-top: 405px;
  position: relative;
  .metadata-description {
    margin-top: 2em;
    h2 {
      font-size: 1.2em;
      font-weight: 600;
      margin-bottom: 1em;
    }
    p {
      font-size: 1em;
      font-weight: 300;
      line-height: 1.5em;
      opacity: 0.8;
    }
  }
  &:before {
    content: "";
    background: linear-gradient(
      180deg,
      rgba(13, 20, 32, 0) 0%,
      rgba(13, 20, 33, 0.65) 56.08%,
      #0d1421 100%
    );
    display: block;
    width: 100%;
    position: absolute;
    height: 380px;
    top: 200px;
    left: 0;
  }
  .metadata {
    opacity: 0.8;
    color: #ffffff;
    font-size: 1em;
    font-weight: 300;
    .genres {
      padding: 0 0.3em;
    }
  }
  h1 {
    color: #ffffff;
  }
  .movie-title {
    margin: 0.5em 0 1em;
  }
}
</style>
